import React from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import { chemistryTheme, Container, Heading, ProductBanner } from 'chemistry'

const Component = ({ bannerItem, product }) => {
  if (!bannerItem && !product) return null

  const { color, loyaltyTitle, ...item } = bannerItem

  return (
    <ChakraProvider resetCSS={true} theme={chemistryTheme}>
      <Container className='target-product' color={color} data-target-product-marker>
        {loyaltyTitle && (
          <Heading
            as='h2'
            fontSize={{ base: '20px', md: '28px' }}
            letterSpacing={{ base: '0.18px' }}
            lineHeight={{ base: '22px', md: '32px' }}
            marginBottom={{ base: '32px' }}
          >
            {loyaltyTitle}
          </Heading>
        )}
        <ProductBanner item={item} {...product} />
      </Container>
    </ChakraProvider>
  )
}

export default { Component }
